export const filterConfigurationApiHash = (treeHash, query, apiHash) => {
  if (!query) {
    return treeHash;
  }
  const lowerQuery = query.toLowerCase();
  const result = {};
  for (const [id, league] of Object.entries(treeHash)) {
    const filteredTournaments = league.children.filter(t => {
      if (t.items) {
        for (const item of t.items) {
          if (item.name.toLowerCase().includes(lowerQuery)) {
            if (apiHash && !apiHash[`3-${item.id}`]) {
              return false;
            }
            return true;
          }
        }
      } else if (t?.name?.toLowerCase().includes(lowerQuery)) {
        if (apiHash && !apiHash[`3-${t?.id}`]) {
          return false;
        }
        return true;
      }
      return false;
    });

    const newLeague = {
      ...league,
      children: filteredTournaments
    };

    if (filteredTournaments.length > 0) {
      result[id] = newLeague;
    } else if (league.items) {
      const item = getPrioritizedItem(league.items);
      if (item.name.toLowerCase().includes(lowerQuery)) {
        result[id] = newLeague;
      }
    } else if (league.name.toLowerCase().includes(lowerQuery)) {
      result[id] = newLeague;
    }
  }

  return result;
};

export const getPrioritizedItem = (items) => {
  return items.reduce((a, c) => {
    if (a.priority > c.priority) {
      a = c;
    }
    return a;
  }, items[0]);
};